module.exports = __webpack_public_path__ + "assets/img/gift.9848083f.jpg";